import {
  Avatar,
  Box,
  Button,
  Container,
  Hidden,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import NavDrawer from "./Drawer";
import logo from "../../assets/logo.png";

import { NavLink } from "react-router-dom";

const Navbar = () => {
  const data = [
    { name: "About", to: "#" },
    { name: "Feature", to: "#" },
    { name: "Benefit", to: "#" },
    { name: "RoadMap", to: "#" },
    { name: "Team", to: "#" },
    { name: "Staking", to: "/staking" },
    { name: "Presale", to: "/presale" },
    { name: "Blogs", to: "#" },
    { name: "Contact", to: "#" },
  ];

  return (
    <Box py={1}>
      <Container>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box display="flex" gap={1} alignItems="center">
            <img src={logo} alt="abc" />
            <NavLink to="/" style={{ textDecoration: "none", color: "white" }}>
              <Box sx={{ fontWeight: "600", fontSize: "22px", color: "white" }}>
                Logo
              </Box>
            </NavLink>
          </Box>

          <Hidden mdDown>
            <Box display="flex" alignItems="center">
              {data.map(({ name, to }, index) => (
                <>
                  <Typography
                    variant="h6"
                    key={index}
                    sx={{
                      display: "block",
                      fontSize: "15px !important",
                      marginRight: "1.5rem",
                      cursor: "pointer",
                      color: "white",
                      fontWeight: "700",
                    }}
                  >
                    <NavLink
                      to={to}
                      style={{ textDecoration: "none", color: "white" }}
                    >
                      {name}
                    </NavLink>
                  </Typography>
                </>
              ))}
              <Button
                sx={{
                  my: 2,
                  color: "white",
                  display: "block",
                  background:
                    "linear-gradient(94.36deg, #074B9E 1.54%, #5BF8FF 92.86%)",
                }}
              >
                WhitePaper
              </Button>
            </Box>
          </Hidden>
          <Hidden mdUp>
            <NavDrawer data={data} />
          </Hidden>
        </Stack>
      </Container>
    </Box>
  );
};
export default Navbar;
